import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Component, OnInit, inject } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig, FormlyFieldProps, FormlyModule } from '@ngx-formly/core';
import { BehaviorSubject, Observable, Subject, debounceTime, of, startWith, switchMap, tap } from 'rxjs';
import { NgIf, NgFor, AsyncPipe, NgForOf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import { toSignal } from '@angular/core/rxjs-interop';
import { AutocompleteOption } from 'app/services/istanze.service';
import { UbicazioneService } from 'app/services/ubicazione.service';
export interface User {
  name: string;
  usermode?: string;
}

@Component({
  selector: 'autocomplete-service-type',
  standalone: true,
  imports: [
    NgFor,
    AsyncPipe,
    MatAutocompleteModule,
    FormlyModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule
  ],
  template: `
    <input
      matInput
      [matAutocomplete]="auto"
      [attr.aria-label]="props.label"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [placeholder]="props.placeholder"
      [errorStateMatcher]="errorStateMatcher"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn((vie$ | async))" (optionSelected)="onOptionSelected($event)">
      <mat-option *ngFor="let option of filter | async" [value]="option.key">
        {{ option.label ? option.label : (option.value?option.value:'') }}
      </mat-option>
    </mat-autocomplete>
    <div>{{(vie$ | async)?.value}}</div>
  `,
})
export class AutocompleteServiceTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  filter: Observable<any>;
  displayValue: any;
  ciccio='ddddddddddddddddddddd'

  opts: User[] = [{ name: 'Mary' }, { name: 'Shelley' }, { name: 'Igor' }];
  filteredOptions: Observable<User[]>;
  private freespins = toSignal(of(this.opts));
  freeSpins$ = new BehaviorSubject(this.opts);


  private ubicazioneService = inject(UbicazioneService)

  vie$:Observable<any>



  displayFn(option: any): any {


    return (option)=>{
      console.log(option)
      return option
    }




  }

  onOptionSelected(selected: MatAutocompleteSelectedEvent){
    console.log(selected)

    if (true){
      this.vie$ = this.ubicazioneService.getViaById(selected.option.value)
    }

    this.props?.optionSelected && this.props.optionSelected(selected.option.value)
  }

  // Funzione che restituisce un Observable<string>
  getDisplayValue(option: any | null): Observable<string> {
    return of(option ? option.label : '');
  }

  ngOnInit() {

    console.log('aaaaaaaaaaaaaaaaaaaaaaaa')
    this.formControl.valueChanges
      .pipe(
        switchMap(value => {


            console.log('aaaaaaaaaaaaaaaaaaaaaaaa')
            //this.props.service(value)
            return this.field.options.formState.cmp._ubicazioneService.getViaById(value)

        }) // Sottoscrivi a displayFn
      )
      .subscribe(display => {
        this.displayValue = display; // Imposta il valore visualizzato
        console.log(display)
      });


    //this.formControl.setValue({key:5,value:"SSSSSSSSSSSSSSSSSSSSSSSSSSSSs"})

    if (!this.props.filter) return
    this.filter = this.formControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      switchMap((term) => this.props.filter(term)),
    );

  }
}
